import { render } from "./TranslationVariants.vue?vue&type=template&id=e3a298d4&scoped=true&ts=true"
import script from "./TranslationVariants.vue?vue&type=script&lang=ts"
export * from "./TranslationVariants.vue?vue&type=script&lang=ts"

import "./TranslationVariants.vue?vue&type=style&index=0&id=e3a298d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3a298d4"]])

export default __exports__